import styled from "styled-components";
import {
  MDBCard,
  MDBCardHeader,
  MDBCardTitle,
  MDBCardBody,
} from "mdb-react-ui-kit";
import { Button, Row, Col } from "../App.styles";
import { Shimmer } from "../common/Loading.styles";

const BrandingRow = styled(Row)`
  margin-top: 1rem;
`;

const BrandingCol = styled(Col)`
  display: block;

  p {
    margin: 1rem 0;
  }

  ${Button} {
    padding-left: 1rem;
    padding-right: 1rem;
    margin-left: 1rem;
  }

  br + ${Button} {
    margin-left: 0;
    margin-top: 1rem;
  }

  video {
    width: 100%;
    height: 528px;
  }
`;

const BrandingPlaceholder = () => {
  return (
    <>
      <Row>
        <MDBCard>
          <MDBCardHeader>
            <MDBCardTitle>
                <Row>
                  <Col lg={6}>
                    <Shimmer type="title" />
                  </Col>
                </Row>
            </MDBCardTitle>
          </MDBCardHeader>
          <MDBCardBody>
            <Row>
              <Col>
                <Shimmer count={2} type="title" />
              </Col>
            </Row>
            <BrandingRow>
              <BrandingCol size="12">
                <Shimmer type="title" />
                <Shimmer count={3} />
              </BrandingCol>
              <BrandingCol size="6">
                <Shimmer type="title" />
                <Shimmer count={3} />
              </BrandingCol>
              <BrandingCol size="6">
              <Shimmer type="title" />
                <Shimmer count={3} />
              </BrandingCol>
            </BrandingRow>
          </MDBCardBody>
        </MDBCard>
      </Row>
    </>
  );
};

export default BrandingPlaceholder;
